import { render, staticRenderFns } from "./VendorStatus.vue?vue&type=template&id=2903586a&scoped=true&"
import script from "./VendorStatus.vue?vue&type=script&lang=js&"
export * from "./VendorStatus.vue?vue&type=script&lang=js&"
import style0 from "./VendorStatus.vue?vue&type=style&index=0&id=2903586a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2903586a",
  null
  
)

export default component.exports